export const hasResponse = <T>(data: unknown): data is { response: T } =>
  typeof data === 'object' &&
  data !== null &&
  'response' in data &&
  (data as { response: unknown }).response !== null;
